import { CustomerDataCustomerInterface } from 'swagger/ts/Definitions';
import { DataStatus, Message, MessageType } from 'src/core/engine';

import { Actions } from './user.actions';

export enum UserSession {
    SignedIn = 'SignedIn',
    SignedOut = 'SignedOut',
}

export type UserState = {
    readonly token: string | null;
    readonly session: UserSession;
    readonly status: DataStatus;
    readonly data: Partial<CustomerDataCustomerInterface>;
    readonly messages: Message[];
    readonly createMessages: Message[];
};

export const initialState: UserState = {
    token: null,
    session: UserSession.SignedOut,
    status: DataStatus.Idle,
    data: {},
    messages: [],
    createMessages: [],
};

export type AppendState<T = {}> = T & { user: UserState };
export type AppendUserState<T = {}> = T & { user: UserState };

export function userReducer(state = initialState, action: Actions): UserState {
    switch (action.type) {
        case 'User.Hydrate': {
            return {
                ...state,
                ...action.payload,
            };
        }
        case 'User.Reset':
        case 'User.SignOut': {
            return {
                ...initialState,
            };
        }
        case 'User.SignInSuccess': {
            return {
                ...state,
                data: {
                    ...action.payload,
                },
                session: UserSession.SignedIn,
                status: DataStatus.Success,
                messages: [],
                createMessages: [],
            };
        }
        case 'User.SetData': {
            return {
                ...state,
                data: {
                    ...action.payload,
                },
            };
        }
        case 'User.SetStatus': {
            return {
                ...state,
                status: action.payload,
            };
        }
        case 'User.SignInSetToken': {
            return {
                ...state,
                token: action.payload.token,
            };
        }
        case 'User.Register':
        case 'User.SignIn': {
            return {
                ...state,
                status: DataStatus.Pending,
                messages: [],
                createMessages: [],
            };
        }
        case 'User.SignInError': {
            return {
                ...state,
                session: UserSession.SignedOut,
                token: null,
                status: DataStatus.Error,
                messages: [{ type: MessageType.Error, text: action.payload }],
            };
        }
        case 'User.RegisterError': {
            return {
                ...state,
                session: UserSession.SignedOut,
                token: null,
                status: DataStatus.Error,
                createMessages: [
                    {
                        type: MessageType.Error,
                        text: action.payload,
                    },
                ],
            };
        }
        default:
            return state;
    }
}
